module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"show-info":"Show information","hide-info":"Hide information","edit-task":"Edit task","delete-task":"Delete task"},"pt-BR":{"show-info":"Mostrar informações","hide-info":"Ocultar informações","edit-task":"Editar tarefa","delete-task":"Excluir tarefa"}}')
  delete Component.options._Ctor
}
